import {
  collection,
  where,
  getFirestore,
  getDocs,
  query,
  setDoc,
  getDoc,
  deleteDoc,
  serverTimestamp,
  doc,
  updateDoc,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import moment from "moment";
import { app } from "../../config/config";
import { REF } from "../ref";
import { TYPES } from "./roster.type";

const firestore = getFirestore(app);
const auth = getAuth();

// ----------- snapshot -------------- //
let rosterSub = [];
export const snapRoster =
  ({ from, to }, callback) =>
  (dispatch) => {
    const owner = auth?.currentUser?.uid;
    const cRef = collection(firestore, REF.ROSTER);
    const start = moment(from)?._d;
    const end = moment(to)?._d;
    const c0 = where("owner", "==", owner);
    const c1 = where("workAt", ">=", start);
    const c2 = where("workAt", "<=", end);
    const qRef = query(cRef, c0, c1, c2);
    const unsub = onSnapshot(qRef, (snapshot) => {
      const data = snapshot.docs.map((doc) => doc.data());
      selectRosterSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    });
    rosterSub.push(unsub);
  };

export const unSnapRoster = () => (dispatch) => {
  rosterSub.forEach((subscriber) => {
    subscriber();
  });

  rosterSub.length = 0;
};

// ---------- dispatch ----------
const selectRosterSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_ROSTER_LIST_SUCCESS,
    payload: data,
  });
};

// -------------------------- Roster Add------------------------ //
export const addorUpdateRoster =
  ({ roster }, callback) =>
  (dispatch) => {
    const owner = auth?.currentUser?.uid;
    const cRef = collection(firestore, REF.ROSTER);
    const workAt = moment(roster.workAt)._d;
    const endAt = moment(roster.endAt)._d;

    if (roster?.id) {
      const id = roster?.id;
      const data = {
        // tạo branch data
        ...roster,
        workAt,
        endAt,
      };
      const dRef = doc(cRef, id);
      updateDoc(dRef, data).then(() => {
        if (callback) {
          callback();
        }
      });
    } else {
      const id = doc(cRef).id;
      const data = {
        // tạo branch data
        ...roster,
        id,
        createAt: serverTimestamp(),
        owner,
        workAt,
        endAt,
      };
      const dRef0 = doc(cRef, id);
      setDoc(dRef0, data, { merge: true }).then(() => {
        if (callback) {
          callback();
        }
      });
    }
  };

// -------------------------- Roster Update---------------------- //
export const updateRosterWeek = ({ rosters }, callback) => {
  const owner = auth?.currentUser?.uid;
  const cRef = collection(firestore, REF.ROSTER);
  rosters.forEach((roster) => {
    const workAt = moment(roster.workAt)._d;
    const endAt = moment(roster.endAt)._d;
    if (roster.id) {
      // tồn tại, lấy id
      const id = roster.id;
      const newData = {
        ...roster,
        workAt,
        endAt,
        updateAt: serverTimestamp(),
      };
      const dRef = doc(cRef, id);
      updateDoc(dRef, newData);
    } else {
      // tạo id data
      const id = doc(cRef).id;
      const newData = {
        ...roster,
        id,
        createAt: serverTimestamp(),
        owner,
        workAt,
        endAt,
      };
      const dRef = doc(cRef, id);
      setDoc(dRef, newData, { merge: true });
    }
  });
};

// ------------------- Delete Roster This Week -------------------- //
export const deleteRosterThisWeek =
  ({ from, to }, callback) =>
  (dispatch) => {
    const owner = auth?.currentUser?.uid;
    const cRef = collection(firestore, REF.ROSTER);
    const start = moment(from)._d;
    const end = moment(to)._d;
    const c0 = where("owner", "==", owner);
    const c1 = where("workAt", ">=", start);
    const c2 = where("workAt", "<=", end);
    const qRef = query(cRef, c0, c1, c2);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        data.forEach((roster) => {
          const id = roster.id;
          const dRef = doc(cRef, id);
          deleteDoc(dRef);
        });
        if (callback) {
          callback();
        }
      } else {
        if (callback) {
          callback();
        }
      }
    });
  };

// -------------------------- Copy Roster ---------------------- //
export const copyRosterLastWeek =
  ({ from, to }, callback) =>
  (dispatch) => {
    // setPreviousRosterSuccess(dispatch, null);
    const owner = auth?.currentUser?.uid;
    const cRef = collection(firestore, REF.ROSTER);
    const start = moment(from).subtract(1, "week")._d;
    const end = moment(to).subtract(1, "week")._d;
    const c0 = where("owner", "==", owner);
    const c1 = where("workAt", ">=", start);
    const c2 = where("workAt", "<=", end);
    const qRef = query(cRef, c0, c1, c2);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        // console.log({ data });
        // setPreviousRosterSuccess(dispatch, data);
        data?.forEach((roster) => {
          // Kiểm tra thời gian
          const workAt = roster?.workAt;
          const newWorkAt =
            workAt &&
            workAt?.seconds &&
            moment(workAt?.toDate()).add(1, "week")._d;
          const endAt = roster?.endAt;
          const newEndAt =
            endAt &&
            endAt?.seconds &&
            moment(endAt?.toDate()).add(1, "week")._d;
          // Thiết lập ngày
          const date = moment(roster.date, "ddd DD MMM YYYY")
            .add(1, "week")
            .format("ddd DD MMM YYYY");
          // tạo id data
          const id = doc(cRef).id;
          const dRef = doc(cRef, id);
          const newData = {
            ...roster,
            id,
            createAt: serverTimestamp(),
            updateAt: serverTimestamp(),
            owner,
            workAt: newWorkAt,
            endAt: newEndAt,
            date,
          };
          setDoc(dRef, newData, { merge: true });
        });
        if (callback) {
          callback();
        }
      }
    });
  };
// dispatch
const setPreviousRosterSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_PREVIOUS_ROSTER_SUCCESS,
    payload: data,
  });
};

// -------------------------- Roster Lock------------------------ //
export const lockRoster =
  ({ from, to }, callback) =>
  (dispatch) => {
    const owner = auth?.currentUser?.uid;
    const cRef = collection(firestore, REF.LOCK_ROSTER);
    const start = moment(from)._d;
    const end = moment(to)._d;
    const id = doc(cRef).id;
    const data = {
      id,
      start,
      end,
      owner,
      createAt: serverTimestamp(),
    };
    const dRef = doc(cRef, id);
    setDoc(dRef, data, { merge: true });
  };

// -------------------------- UnLock Roster ----------------------- //
export const unLockRoster =
  ({ lock }, callback) =>
  (dispatch) => {
    const owner = auth?.currentUser?.uid;
    const cRef = collection(firestore, REF.LOCK_ROSTER);
    const id = lock.id;
    const dRef = doc(cRef, id);
    deleteDoc(dRef);
  };

// ---------------------- Snapshot Lock Roster ----------------------- //
let lockSub = [];
export const snapLockRoster =
  ({ from, to }, callback) =>
  (dispatch) => {
    const owner = auth?.currentUser?.uid;
    const start = moment(from)?._d;
    const end = moment(to)?._d;
    const cRef = collection(firestore, REF.LOCK_ROSTER);
    const c0 = where("owner", "==", owner);
    const c1 = where("start", ">=", start);
    const c2 = where("start", "<=", end);
    const qRef = query(cRef, c0, c1, c2);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        const lock = data[0] || null;
        selectLockRosterSuccess(dispatch, lock);
        if (callback) {
          callback();
        }
      }
    });
    lockSub.push(unsub);
  };

export const unSnapLockRoster = () => (dispatch) => {
  lockSub.forEach((subscriber) => {
    // Xóa bỏ subscribe snapshot nếu out
    subscriber();
  });
  lockSub.length = 0;
};

const selectLockRosterSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_LOCK_ROSTER_LIST_SUCCESS,
    payload: data,
  });
};

// ---------------------- Create or Update Roster ----------------------- //
export const addRoster =
  ({ datas }, callback) =>
  (dispatch) => {
    const owner = auth?.currentUser?.uid;
    const cRef = collection(firestore, REF.ROSTER);
    datas?.forEach((data) => {
      const action = data?.action;
      if (action === "create") {
        const id = doc(cRef).id;
        const dRef = doc(cRef, id);
        const create = {
          ...data,
          id,
          owner,
          createAt: serverTimestamp(),
        };
        setDoc(dRef, create, { merge: true });
      } else {
        const id = data?.roster;
        const dRef = doc(cRef, id);
        const update = {
          ...data,
          updateAt: serverTimestamp(),
        };
        updateDoc(dRef, update);
      }
    });

    if (callback) {
      callback();
    }
  };
